export default defineNuxtRouteMiddleware((to) => {
  if (to.meta.public) return;

  // An error triggered during the `/_auth/callback` route will render
  // `app/error.vue` and trigger this middleware, detect a lack of session,
  // then redirect to the login page with no error. The following line ensures
  // that the app shows the error page instead of redirecting away.
  // TODO: redirect to the login page with an error: https://dev.azure.com/midlandgaragedoor/IT/_workitems/edit/3214
  if (to.path.startsWith("/_auth/")) return;

  const { loggedIn } = useAppSession();
  if (!loggedIn.value) {
    return navigateTo("/login");
  }
});

declare module "#app" {
  interface PageMeta {
    public?: true;
  }
}
